import { Body, Button } from '@hover/blueprint';
import type { IconProp } from '@hover/icons';
import { iconLink } from '@hover/icons';
import React from 'react';

import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { buttonPressed } from 'src/shared/telemetry';

import { useOnboardingMagicLink } from '../hooks/useOnboardingMagicLink';

type MagicLinkButtonVariant = {
  pageOrScreenName: string;
  to: string;
  isEmailAndSignUpOptionsCombined?: boolean;
  email?: string;
};

const MagicLinkButton = ({
  icon,
  label,
  pageOrScreenName,
  to,
  isEmailAndSignUpOptionsCombined = false,
  email,
}: {
  icon: IconProp;
  label: string;
  pageOrScreenName: string;
  to: string;
  isEmailAndSignUpOptionsCombined?: boolean;
  email?: string;
}) => {
  const { handleOnClickMagicLink } = useOnboardingMagicLink({
    isEmailAndSignUpOptionsCombined,
    redirectToUrl: to,
  });

  const handleOnClick = async () => {
    buttonPressed({
      button_text: label,
      page_or_screen_name: pageOrScreenName,
      feature: 'onboarding',
    });

    await handleOnClickMagicLink(email);
  };

  return (
    <Button
      aria-label={label}
      fill="outline"
      iconBefore={icon}
      onClick={handleOnClick}
      p={400}
      size="large"
      testId="continue-with-email"
      textDecoration="none"
      type={isEmailAndSignUpOptionsCombined ? 'submit' : 'button'}
      variant="secondary"
    >
      <Body>{label}</Body>
    </Button>
  );
};

export const EmailMeALinkButton = ({
  pageOrScreenName,
  to,
  isEmailAndSignUpOptionsCombined,
  email,
}: MagicLinkButtonVariant) => {
  const t = useTranslate(TranslationNamespace.SHARED);

  return (
    <MagicLinkButton
      email={email}
      icon={iconLink}
      isEmailAndSignUpOptionsCombined={isEmailAndSignUpOptionsCombined}
      label={t('onboarding.emailMeALink')}
      pageOrScreenName={pageOrScreenName}
      to={to}
    />
  );
};
